<template>
  <v-container fluid>
    <CustomersTable class="pb-4">
      <template v-slot:actions="{ dataset }">
        <avs-exportButton
          :data="dataset"
          :prepare="preFmtData"
          :name="$t('actions.export_')"
          :spantext="
            $t('actions.export', {
              entity: $tc('Client').toLowerCase()
            })
          "
        />
        <avs-button
          color="success"
          iconI="mdi-file-excel"
          text
          :loading="exportingExcel"
          :name="$t('Excel')"
          :spantext="$t('Exporter la liste des clients en Excel')"
          @click="handleExportExcel"
        >
          <template v-slot:name>{{ $t("Excel") }}</template>
        </avs-button>
        <avs-createButton
          @click="handleNewInspection"
          :spantext="$tc('Creer un client', 1).toLowerCase()"
          :name="$tc('Nouveau client', 1).toLowerCase()"
        />
      </template>
    </CustomersTable>
  </v-container>
</template>
<script>
import CustomersTable from "@/components/ri3/customer/CustomersTable.vue"
import { CustomerService } from "@/services"
import InspectionService from "@/services/InspectionService"
import { now, add } from "@/utils/datetime"
import { fmtInspectionData } from "@/utils/download"

export default {
  name: "CustomersView",
  components: { CustomersTable },
  computed: {
    project() {
      return this.$store.state.app.project
    }
  },
  data() {
    return {
      loading: false,
      exportingExcel: false,
      newMenuItems: [
        {
          text: this.$t("categories.inspection.quick"),
          icon: "mdi-clipboard-text-clock-outline",
          function: this.handleNewMeeting
        },
        {
          text: this.$t("categories.inspection.plan"),
          icon: "mdi-calendar-cursor",
          function: this.handleNewInspection
        }
        // {
        //   text: this.$t("categories.inspection.fill"),
        //   icon: "mdi-file-document-edit-outline",
        //   function: this.handleNewInspectionForm
        // }
      ]
    }
  },
  methods: {
    createInspection(redirectPath, tab = null, notify = false) {
      this.loading = true
      const startDate = now()
      const endDate = add(now(), 1, "h")
      InspectionService.create(this, this.project.id, {
        name: "NONE",
        start_date: startDate,
        end_date: endDate,
        status: "Ongoing",
        notify_oncreated: notify,
        lang: this.$i18n.locale
      })
        .then(r => {
          this.$store.commit("app/message", {
            msg: this.$t("messages.success.created", {
              entity: this.$tc("categories.inspection.name", 1)
            }),
            color: "success"
          })
          this.$router.push({
            name: redirectPath,
            params: { id: r.id, uuid: r.uuid, tab: tab }
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleNewInspection() {
      this.$router.push({
        name: "CustomerCreateUpdate"
      })
    },
    handleNewInspectionForm() {
      this.createInspection("Inspection", 2)
    },
    handleNewMeeting() {
      this.createInspection("InspectionMeeting", null, false)
    },
    preFmtData(dataset) {
      return fmtInspectionData(dataset)
    },
    async handleExportExcel() {
      this.exportingExcel = true
      try {
        await CustomerService.exportExcel(this.project && this.project.id)
      } catch (e) {
        this.$store.commit("app/message", {
          msg: this.$t("Erreur lors de l'export Excel"),
          color: "error"
        })
      } finally {
        this.exportingExcel = false
      }
    }
  }
}
</script>
